export const CHANGE_TO_FAVORITE_LIST = 'CHANGE_TO_FAVORITE_LIST'
export const RESET_FAVORITE_LIST = 'RESET_FAVORITE_LIST'
